import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Privacy from '../views/Privacy.vue'
import Terms from '../views/Terms.vue'
import AdminAuth from '../components/AdminAuth.vue'
import AdminDashboard from '../components/Dashboard.vue'
import UserDetailView from '../components/UserDetailView.vue'

const getAdminAuthCookie = () => {
  const cookies = document.cookie.split(';')
  const adminCookie = cookies.find(cookie => cookie.trim().startsWith('adminAuth='))
  return adminCookie ? adminCookie.split('=')[1].trim() : null
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminAuth
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: AdminDashboard,
    meta: { requiresAdmin: true }
  },
  {
    path: '/user/:id',
    name: 'userDetail',
    component: UserDetailView,
    meta: { requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    const hasAdminAuth = getAdminAuthCookie()
    if (!hasAdminAuth) {
      next('/admin')
      return
    }
  }
  next()
})

export default router
